import Image from '@components/Image';
import { MEDIA_DOMAIN, PUBLIC_DOMAIN } from '@constants';
import useEditingStore from '@hooks/useEditingStore';
import { $templateId, $tourData } from '@stores/dataStores';
import {
  $GateSearchBtn,
  $editingCategoryConfig,
  $editingCustomButton,
  $editingUIColor,
} from '@stores/editingStores';
import { $isCn } from '@stores/langStores';
import { $panel } from '@stores/panelStores';
import { EditConfigLanguageType, ImageType, TemplateId } from '@types';
import { modifyUiValue } from '@utils/modifyUiValue';
import { getTemplateConfig } from '@utils/templateConfig';
import { getMediaUrl, getSysUrl } from '@utils/urlMakers';
import classNames from 'classnames';
import { useStore } from 'effector-react';
// @ts-ignore
import PanoCustomButton, {
  Theme8Button,
  Theme3Button,
  Button as CategoryButton,
  // @ts-ignore
} from 'pano-custom-button';
/* eslint-disable unused-imports/no-unused-vars */
import { useState } from 'react';

export function CustomButtonWidget() {
  const customButton = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.customButton,
    $editing: $editingCustomButton.store,
  });
  const categoryConfig = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.categoryConfig,
    $editing: $editingCategoryConfig.store,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.ui,
    $editing: $editingUIColor.store,
  });
  const isCn = useStore($isCn);
  const templateId = useStore($templateId);
  const hasFeature = getTemplateConfig(templateId)('customButton');

  const [activityGroups, setActivityGroups] = useState<number[]>(() => {
    const panelState = $panel.getState();

    if (
      panelState.type === 'customButton' ||
      panelState.type === 'customGroup'
    ) {
      return [panelState.groupIndex];
    }
    return [];
  });

  const showCategoryButton =
    !!categoryConfig?.enabledButton &&
    [
      TemplateId.vip,
      TemplateId.free,
      TemplateId.legacy,
      TemplateId.simple,
    ].includes(templateId);

  const getCategoryBtnSrc = () => {
    if (!categoryConfig?.buttonMediaUrl) return null;
    return categoryConfig?.buttonMediaId === 0
      ? getSysUrl(categoryConfig.buttonMediaUrl)
      : getMediaUrl(categoryConfig.buttonMediaUrl);
  };

  // 去除id，会引发组件 bug
  const cBtn = customButton?.map((btn) => ({
    ...btn,
    children: btn.children.map((y) => {
      // @ts-ignore
      const { id, ...rest } = y;
      return rest;
    }),
  }));

  if (
    templateId === TemplateId.project ||
    templateId === TemplateId.metaverseA
  ) {
    return (
      <PanoCustomButton
        ui={modifyUiValue(ui)}
        MEDIA_DOMAIN={MEDIA_DOMAIN}
        PUBLIC_DOMAIN={PUBLIC_DOMAIN}
        imgSuffix={(size: number) => `?imageView2/0/w/${size}/h/${size}`}
        language={isCn ? EditConfigLanguageType.cn : EditConfigLanguageType.en} // 1中文, 2英文
        customButton={cBtn}
        handleClick={() => {}}
        activityGroups={activityGroups}
        onClickGroup={(idx: number) => {
          setActivityGroups((prev) => {
            if (prev.includes(idx)) {
              return prev.filter((x) => x !== idx);
            }
            return [...prev, idx];
          });
        }}
        templateId={templateId}
        enableEvent
      />
    );
  }

  return (
    <div
      className={classNames('absolute flex', {
        'left-10  bottom-0':
          templateId !== TemplateId.realEstateA &&
          templateId !== TemplateId.realEstateB &&
          templateId !== TemplateId.simple,
        'bottom-24': templateId === TemplateId.realEstateA,
        'bottom-10 w-[500px]': templateId === TemplateId.realEstateB,
        'bottom-0 left-0 w-full justify-center':
          templateId === TemplateId.simple,
        'z-[5000]': templateId === TemplateId.legacy,
      })}
      style={{
        ...(templateId === TemplateId.simple && {
          backgroundColor: `rgba(${ui?.panelBgColor})`,
        }),
      }}
    >
      {showCategoryButton && templateId === TemplateId.legacy && (
        <Theme8Button
          ui={modifyUiValue(ui)}
          src={getCategoryBtnSrc()}
          title={categoryConfig?.buttonTitle || (isCn ? '场景选择' : 'List')}
        >
          {' '}
        </Theme8Button>
      )}
      {showCategoryButton && templateId === TemplateId.vip && (
        <CategoryButton ui={modifyUiValue(ui)} src={getCategoryBtnSrc()}>
          {categoryConfig?.buttonTitle || (isCn ? '场景选择' : 'List')}
        </CategoryButton>
      )}
      {showCategoryButton &&
        !!cBtn?.length &&
        templateId === TemplateId.simple && (
          <Theme3Button
            ui={modifyUiValue(ui)}
            src={getCategoryBtnSrc()}
            title={categoryConfig?.buttonTitle || (isCn ? '场景选择' : 'List')}
          >
            {' '}
          </Theme3Button>
        )}

      {!!(hasFeature && cBtn?.length) && (
        <PanoCustomButton
          ui={modifyUiValue(ui)}
          MEDIA_DOMAIN={MEDIA_DOMAIN}
          PUBLIC_DOMAIN={PUBLIC_DOMAIN}
          imgSuffix={(size: number) => `?imageView2/0/w/${size}/h/${size}`}
          language={
            isCn ? EditConfigLanguageType.cn : EditConfigLanguageType.en
          } // 1中文, 2英文
          customButton={cBtn}
          handleClick={() => {}}
          activityGroups={activityGroups}
          onClickGroup={(idx: number) => {
            setActivityGroups((prev) => {
              if (prev.includes(idx)) {
                return prev.filter((x) => x !== idx);
              }
              return [...prev, idx];
            });
          }}
          templateId={templateId}
          enableEvent
        />
      )}
    </div>
  );
}

function MetaASearchIcon() {
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });
  if (!showSearch) return null;
  return (
    <div className="mt-10 flex h-50 w-50 items-center justify-center rounded bg-black-black bg-opacity-50">
      <Image
        src="/imgs/search.4e1549dd38bdb38a07a3fc96c7b9495a.png"
        type={ImageType.sysMedia}
        className="h-30 w-30"
      />
    </div>
  );
}
